import { cloneDeep } from 'lodash'

import { domainsUsers } from '@/components/services/url-shortener-settings/utils'

import render from './render'

export default {
  name: 'DomainId',

  mixins: [ domainsUsers ],

  props: {
    value: String,
    userId: String,

    disabled: Boolean,
    required: Boolean,
    setRequiredOnMounted: Boolean,

    showWarnings: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      proxy: cloneDeep(this.value)
    }
  },

  computed: {
    domainIsNotInDomainsUsers() {
      return this.value && !this.domainsUsers.find(item => {
        return item?.domainId === this.value
      })
    },
    domainIsNotInActiveDomains() {
      return this.value && !this.activeDomains.find(item => {
        return item?.domainId === this.value
      })
    },

    hasWarnings() {
      return !this.hasActiveDomains || this.domainIsNotInDomainsUsers || this.domainIsNotInActiveDomains
    },
    warningPath() {
      if (!this.hasActiveDomains) {
        return 'warnings.domains'
      }
      if (this.domainIsNotInDomainsUsers) {
        return 'warnings.domainId.notInDomainsUsers'
      }
      if (this.domainIsNotInActiveDomains) {
        return 'warnings.domainId.notInActiveDomains'
      }
    }
  },

  watch: {
    value(value) {
      this.proxy = cloneDeep(value)
    }
  },

  render
}
